/**
Author - Vikrant Singh
Git - git@github.com:vikrantSingh97
**/

import CheckAcess from "./CheckAccess.container";

export default CheckAcess;
